import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Slider from 'react-slick';
import imgFbDefault from '../assets/img/webp/slick-no-img.webp';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const SocialWall = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(null);

  const pageId = process.env.REACT_APP_FB_PAGE_ID;
  const accessToken = process.env.REACT_APP_FB_ACCESS_TOKEN;
  const fields = 'id,message,created_time,full_picture,permalink_url';
  const corsProxy = 'https://corsproxy.io/?';
  
  const fetchPosts = async (force = false) => {
    if (loaded && !force) return;
    
    setLoading(true);
    setError(null);
    
    try {
      const url = `${corsProxy}https://graph.facebook.com/v22.0/${pageId}/posts?fields=${fields}&access_token=${accessToken}&limit=6`;
      const response = await axios.get(url);
      setPosts(response.data.data);
      setLoaded(true);
    } catch (err) {
      setError('Erreur lors de la récupération des posts');
      console.error('Erreur:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPosts();
  }, []);

  // Fonction pour formater la date
  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('fr-FR', options);
  };

  // Configuration de Slick Carousel
  const slickSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  };

  if (error) {
    return <div className="error-message">Une erreur est survenue lors du chargement.</div>;
  }

  return (
    <div className="social-wall-fb">
      <h2>Suivez-nous</h2>
      {loading ? (
         <div className="text-center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Chargement en cours...</span>
          </div>
        </div>
      ) : posts.length === 0 ? (
        <p>Aucun post trouvé</p>
      ) : (
        <Slider {...slickSettings} className="posts-slider">
          {posts.map(post => (
            <div key={post.id} className="post-slide">
              <div className="post-card">
                <a 
                  href={post.permalink_url} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="post-link"
                >
                  <div className="post-image-container">
                    <img 
                      src={post.full_picture || imgFbDefault} 
                      alt="Contenu du post" 
                      className="post-image" 
                    />
                  </div>
                  {post.message && (
                    <div className="post-message">
                      {post.message.length > 150 
                        ? `${post.message.substring(0, 150)}...` 
                        : post.message}
                    </div>
                  )}
                  <div className="post-footer">
                    <span className="post-date">
                      Publié le {formatDate(post.created_time)}
                    </span>
                  </div>
                </a>
              </div>
            </div>
          ))}
        </Slider>
      )}
    </div>
  );
};

export default SocialWall;